import { BaseSerializer } from "./baseSerializer.ts";
import { LaunchKeyDates } from "../launchKeyDates.model.ts";


export class LaunchKeyDatesSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new LaunchKeyDates();
        this._copyAttributes(gp, data);
        return gp;

    }

}
